import React from 'react'
import App from 'app'
import { createRoot } from 'react-dom/client'
import reducers from 'careers/reducers'
import routes from 'careers/routes'
import { initializeStore } from '../store'
import Router from '../components/router/router'

export default function () {
  if (!document.querySelector('#localstorage-error')) {
    const root = createRoot(document.querySelector('#container'))
    return initializeStore(reducers).then(({ store }) =>
      root.render(
        <App store={store}>
          <Router routes={routes} />
        </App>
      )
    )
  }
  return Promise.resolve()
}
